import { Wrapper } from "shared/ui/Wrapper/Wrapper";
import { useEffect, useState } from "react";
import { classNames } from "shared/lib/classNames/classNames";
import { useDispatch, useSelector } from "react-redux";
import {
    APIAllProductsResponse,
    APIProductTypes,
    APIUser,
} from "app/api/APITypes";
import { useApi } from "app/api/APIProvider";
import { GoodCard } from "entities/GoodCard";
import { GoodCardTheme } from "entities/GoodCard/ui/GoodCard";
import { Tabs } from "shared/ui/Tabs";
import { TabsTheme } from "shared/ui/Tabs/Tabs";
import { getShopProducts } from "features/Services";
import { Text, TextSize } from "shared/ui/Text/Text";
import { Title, TitleSize } from "shared/ui/Title/Title";
import { Selector } from "shared/ui/Selector/Selector";
import { InfoCard } from "entities/InfoCard";
import { AssistantOverlay } from "features/AssistantOverlay";
import { Button, ButtonTheme } from "shared/ui/Button/Button";
import { AppLink } from "shared/ui/AppLink/AppLink";
import Logo from "shared/assets/img/sber_logo.png";
import PlayIcon from "shared/assets/icons/playIcon.svg";
import cls from "./ShopPage.module.scss";
import { userActions } from "features/User";

interface IProduct {
    section: string;
    section_name: string;
    products: Array<{
        id: number;
        name: string;
        type: string;
        required_level: number;
        unique_key: string;
        price: number;
        max_amount: number;
    }>;
}

export const ShopPage = () => {
    const api = useApi();
    const user = api.User;
    const dispatch = useDispatch();
    const [products, setProducts] = useState([]);
    // const products = useSelector(getShopProducts);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [isShopSection, setIsShopSection] = useState<boolean>(false);
    // const [productsAmount, setProductsAmount] = useState<any>({});

    const shopTabs: { name: string; filter?: APIProductTypes }[] = [
        { name: "Все" },
        { name: "Техника", filter: "tech" },
        { name: "Еда", filter: "food" },
        { name: "Развлечения", filter: "entertainment" },
        { name: "Аксессуары", filter: "accessories" },
        { name: "Недвижимость", filter: "realty" },
        { name: "Спорт и отдых", filter: "sport" },
        { name: "Транспорт", filter: "transport" },
    ];

    const messagesForAssistant: { [key: number]: string } = {
        1:
            "В нашем магазине много интересных, полезных или просто красивых вещей. " +
            "Напротив каждой вещи-товара проставлена цена, за которую ты можешь что-то приобрести. " +
            "Если денег не хватает, товар купить не получится.",
        2:
            "Сегодня в магазине супер акция! Любая техника на 10% дешевле! " +
            "Если тебе понравился товар, но денег не хватает, ты можешь оформить кредит (доступно только если у тебя есть работа). " +
            "Для оформления кредита заходи во вкладку Мои финансы",
        3: "Во взрослой жизни нужно много успевать. Автомобиль может помочь в этом. А если тебе нужен кредит, то заходи во вкладку Мои финансы",
        4: "А если тебе потребуется кредит или страхование имущества, то заходи во вкладку Мои финансы",
    };

    const setActiveTabButton = (
        index: number,
        filter?: APIProductTypes,
        activeTab?: any
    ) => {
        setActiveTabIndex(activeTab);
    };

    useEffect(() => {
        //@ts-ignore
        api.GetProducts({}).then((res) => {
            setProducts(res);
            dispatch(userActions.setCurrentInitCart(res));
        });
    }, []);

    useEffect(() => {
        const showShopSection = sessionStorage.getItem("showShopSection");

        if (showShopSection === "Показать") {
            setIsShopSection(true);
        } else {
            setIsShopSection(false);
        }
    }, []);

    return (
        <div className={cls.page}>
            <Wrapper className={cls.mainWrapper}>
                <main className={cls.main}>
                    <AssistantOverlay
                        switcher={isShopSection}
                        message={messagesForAssistant[user.level]}
                        section="showShopSection"
                    ></AssistantOverlay>
                    <Text
                        className={cls.mainTitle}
                        color="#353850"
                        size={TextSize.text_36}
                    >
                        Категории
                    </Text>
                    <div className={cls.tabsButtonWrapper}>
                        <Tabs
                            shopTabs={shopTabs}
                            type={TabsTheme.V1}
                            theme="shop"
                            cb={setActiveTabButton}
                        />
                    </div>
                    <div className={cls.selectorWrapper}>
                        <Selector
                            options={shopTabs}
                            callback={setActiveTabButton}
                        />
                    </div>
                    <div className={cls.contentWrapper}>
                        {activeTabIndex === 0 ? (
                            products.map(
                                (
                                    {
                                        section,
                                        products,
                                        section_name,
                                    }: IProduct,
                                    index: number
                                ) => {
                                    return (
                                        <div
                                            className={cls.contentSection}
                                            key={`${section} ${index}`}
                                        >
                                            <Title
                                                className={cls.title}
                                                color="#353850"
                                                size={TitleSize.title_20}
                                            >
                                                {section_name}
                                            </Title>
                                            <div className={cls.cardsWrapper}>
                                                {products.map(
                                                    (item: any, index) => {
                                                        return (
                                                            <div
                                                                className={
                                                                    cls.goodCard
                                                                }
                                                                key={index}
                                                            >
                                                                <div
                                                                    className={classNames(
                                                                        "",
                                                                        {
                                                                            //@ts-ignore
                                                                            [cls.disableCard]:
                                                                                item.required_level >
                                                                                    1 &&
                                                                                user.level <
                                                                                    item.required_level,
                                                                        }
                                                                    )}
                                                                >
                                                                    <GoodCard
                                                                        product={
                                                                            item
                                                                        }
                                                                        key={`${item.name} ${index}`}
                                                                        theme={
                                                                            GoodCardTheme.shop
                                                                        }
                                                                    />
                                                                </div>
                                                                <div
                                                                    className={classNames(
                                                                        cls.requiredLevelTablet,
                                                                        {
                                                                            //@ts-ignore
                                                                            [cls.visible]:
                                                                                item.required_level >
                                                                                    1 &&
                                                                                user.level <
                                                                                    item.required_level,
                                                                        }
                                                                    )}
                                                                >
                                                                    <Text
                                                                        className={
                                                                            cls.cardTitle
                                                                        }
                                                                        color="#353850"
                                                                        size={
                                                                            TextSize.text_16
                                                                        }
                                                                    >
                                                                        {`Откроется на ${item.required_level} уровне`}
                                                                    </Text>
                                                                </div>
                                                                <div
                                                                    className={classNames(
                                                                        cls.discount,
                                                                        {
                                                                            [cls.visible]:
                                                                                item.sale >
                                                                                0,
                                                                        }
                                                                    )}
                                                                >
                                                                    <Text
                                                                        className={
                                                                            cls.cardTitle
                                                                        }
                                                                        color="#FFF"
                                                                        size={
                                                                            TextSize.text_16
                                                                        }
                                                                    >
                                                                        Скидка
                                                                        10%
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    );
                                }
                            )
                        ) : (
                            //@ts-ignore
                            <div
                                className={cls.contentSection}
                                key={`${products[activeTabIndex]?.section}`}
                            >
                                <Title
                                    className={cls.title}
                                    color="#353850"
                                    size={TitleSize.title_20}
                                >
                                    {
                                        //@ts-ignore
                                        products[activeTabIndex - 1]
                                            .section_name
                                    }
                                </Title>
                                <div className={cls.cardsWrapper}>
                                    {
                                        //@ts-ignore
                                        products[
                                            activeTabIndex - 1
                                        ]?.products.map(
                                            (item: any, index: number) => {
                                                return (
                                                    <div
                                                        className={cls.goodCard}
                                                        key={item.name}
                                                    >
                                                        <div
                                                            className={classNames(
                                                                "",
                                                                {
                                                                    //@ts-ignore
                                                                    [cls.disableCard]:
                                                                        item.required_level >
                                                                            1 &&
                                                                        user.level <
                                                                            item.required_level,
                                                                }
                                                            )}
                                                        >
                                                            <GoodCard
                                                                product={item}
                                                                key={`${item.name} ${index}`}
                                                                theme={
                                                                    GoodCardTheme.shop
                                                                }
                                                            />
                                                        </div>
                                                        <div
                                                            className={classNames(
                                                                cls.requiredLevelTablet,
                                                                {
                                                                    //@ts-ignore
                                                                    [cls.visible]:
                                                                        item.required_level >
                                                                            1 &&
                                                                        user.level <
                                                                            item.required_level,
                                                                }
                                                            )}
                                                        >
                                                            <Text
                                                                className={
                                                                    cls.cardTitle
                                                                }
                                                                color="#353850"
                                                                size={
                                                                    TextSize.text_16
                                                                }
                                                            >
                                                                {`Откроется на ${item.required_level} уровне`}
                                                            </Text>
                                                        </div>
                                                        <div
                                                            className={classNames(
                                                                cls.discount,
                                                                {
                                                                    [cls.visible]:
                                                                        item.sale >
                                                                        0,
                                                                }
                                                            )}
                                                        >
                                                            <Text
                                                                className={
                                                                    cls.cardTitle
                                                                }
                                                                color="#FFF"
                                                                size={
                                                                    TextSize.text_16
                                                                }
                                                            >
                                                                Скидка 10%
                                                            </Text>
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        )
                                    }
                                </div>
                            </div>
                        )}
                    </div>
                </main>
                <AppLink to="/plot" className={cls.backToGameButton}>
                    <Button
                        theme={ButtonTheme.BACK_TO_GAME}
                        icon={<PlayIcon />}
                    >
                        Продолжить сюжет
                    </Button>
                </AppLink>
                <img className={cls.logo} src={Logo} alt="Разумные деньги фото №19" />
            </Wrapper>
        </div>
    );
};
